function numberValidator() {
  return {
    restrict: "A",
    link: function (scope, element) {
      element.on("keydown", function (event) {
        if (event.which === 69) {
          event.preventDefault();
        }
        return true;
      });
    },
  };
}

export default numberValidator;
